<template>
  <div>
    <div
      class="mb-4 flex justify-between space-x-8"
      aria-label="Tabs"
    >
      <button
        v-for="tab in tabs"
        :key="tab.value"
        :class="[
          tab.value === modelValue
            ? 'border-primary text-primary'
            : 'border-transparent text-background-fg/50 hover:border-background-fg/70 hover:text-background-fg/70',
          'grow whitespace-nowrap border-b-2 px-1 py-4 text-sm font-semibold',
        ]"
        @click="emit('update:modelValue', tab.value)"
      >
        {{ tab.label }}
      </button>
    </div>
  </div>
</template>

<script setup lang="ts">
defineProps<{
  modelValue: string
  tabs: Array<{
    value: string
    label: string
  }>
}>()

const emit = defineEmits<{
  (event: "update:modelValue", value: string): void
}>()
</script>
